import { render, staticRenderFns } from "./select-button.vue?vue&type=template&id=7071d57e&scoped=true"
import script from "./select-button.vue?vue&type=script&lang=ts"
export * from "./select-button.vue?vue&type=script&lang=ts"
import style0 from "./select-button.vue?vue&type=style&index=0&id=7071d57e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7071d57e",
  null
  
)

export default component.exports